@use "~theme/breakpoints";
@use "~theme/typography";

// The base card has some layout baggage we don't need. Unset them.
.card {
  margin: unset;
  max-width: unset;
}

.title {
  @include typography.body-large;
  color: var(--blue-01);
  margin: 0;
  padding: 16px 24px;
  border-bottom: 1px solid var(--blue-02-at-30);
}

.content {
  padding: 16px 24px 32px;

  @include breakpoints.desktop {
    padding: 16px 28px 36px;
  }
}

.caption {
  margin: 8px 0 0;
}
